import React from 'react';
import { Helmet } from 'react-helmet-async';
import { APP_NAME } from '../../App.constants';

export const SEO: React.FC<{ title: string }> = ({ title }) => {
	return <Helmet title={`${APP_NAME} | ${title}`} />;
};
